import { PickupEventEditPage } from "components/shared/pickupEvents";

export const EditPickupEvent: React.FC = () => (
  <PickupEventEditPage variant="admin" />
);
